"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = logCategoryActionLabel;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _webApiClientSingleton = _interopRequireDefault(require("../webApiClientSingleton"));
var _logging = require("../player/constants/logging");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function logCategoryActionLabel(event, moreParams) {
  var params = _objectSpread({
    c: 'eventlist'
  }, moreParams);
  if (!event.category) {
    event.category = _logging.categories.ad;
  }
  _webApiClientSingleton["default"].instance.logging.eventLog({
    event: event,
    params: params
  });
}
//# sourceMappingURL=logCategoryActionLabel.js.map